// extracted by mini-css-extract-plugin
module.exports = {"review-instruction":"review-instruction__3Argw"};